import ssfRest from '../np-rest/ssfRest';

const restLoad = props => {
    const [SSFRest] = ssfRest(props);
    return [SSFRest]
}

export default restLoad;